import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import Sidebar from './Sidebar';
import './Dashboard.css';

const CustomerSupport = () => {
    const navigate = useNavigate();
    const [iframeLoaded, setIframeLoaded] = useState(false);

    const userEmail = localStorage.getItem('email') || '';
    const avatarInitials = userEmail
        ? userEmail.split('@')[0].slice(0, 2).toUpperCase()
        : '??';

    const supportUrl = `https://intercom-chefcoco.web.app/?id=&email=${encodeURIComponent(userEmail)}`;

    const handleLogout = () => {
        localStorage.removeItem('x-cc-auth');
        window.location.href = '/';
    };

    return (
        <div className="dashboard-container">
            <Sidebar
                currentPath="/support"
                onNavigate={(path) => navigate(path)}
                onLogout={handleLogout}
            />

            <div className="main-content" style={{ display: 'flex', flexDirection: 'column' }}>
                {/* Topbar */}
                <div className="topbar">
                    <div className="topbar-title">
                        <h2>Customer Support</h2>
                        <span className="topbar-badge">Help · Support</span>
                    </div>
                    <button className="avatar-btn" title={userEmail}>{avatarInitials}</button>
                </div>

                {/* Iframe container */}
                <div style={{ flex: 1, padding: '20px 24px', display: 'flex', flexDirection: 'column' }}>
                    <div style={{
                        flex: 1,
                        borderRadius: '16px',
                        border: '1px solid #e5e7eb',
                        overflow: 'hidden',
                        background: '#fff',
                        position: 'relative',
                        minHeight: '600px',
                    }}>
                        {!iframeLoaded && (
                            <div style={{
                                position: 'absolute', inset: 0,
                                display: 'flex', flexDirection: 'column',
                                alignItems: 'center', justifyContent: 'center',
                                gap: '12px', color: '#9ca3af',
                            }}>
                                <MessageCircle size={36} color="#d1d5db" />
                                <span style={{ fontSize: '14px' }}>Loading support chat…</span>
                            </div>
                        )}
                        <iframe
                            src={supportUrl}
                            title="Customer Support"
                            style={{
                                width: '100%',
                                height: '100%',
                                border: 'none',
                                display: iframeLoaded ? 'block' : 'none',
                                minHeight: '600px',
                            }}
                            onLoad={() => setIframeLoaded(true)}
                            allow="microphone; camera"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomerSupport;
